import React from "react";
import {listOf} from "../sectionText";
import CountUp from "../CountUp";

export function CardsBlock({data}) {
    const items = listOf(data, "items", []);
    if (items.length === 0) return null;
    return (
        <div className="block-cards">
            {items.map((item, i) => (
                <div key={i} className="custom-card">
                    {item.emoji && <span aria-hidden="true" className="custom-card__emoji">{item.emoji}</span>}
                    {item.title && <h3>{item.title}</h3>}
                    {item.text && <p>{item.text}</p>}
                </div>
            ))}
        </div>
    );
}

export function KeyFigureBlock({data}) {
    if (!data.value) return null;
    return (
        <div className="block-key-figure">
            <strong><CountUp value={data.value} enabled={data.count_up === "oui"}/></strong>
            {data.label && <span>{data.label}</span>}
        </div>
    );
}

export function StepsBlock({data}) {
    const items = listOf(data, "items", []);
    if (items.length === 0) return null;
    return (
        <ol className="block-steps">
            {items.map((item, i) => (
                <li key={i}>
                    {item.title && <strong>{item.title}</strong>}
                    {item.text && <p>{item.text}</p>}
                </li>
            ))}
        </ol>
    );
}

// Questions repliables : <details>/<summary> natifs, donc utilisables au clavier et par les lecteurs d'écran.
export function FaqBlock({data}) {
    const items = listOf(data, "items", []);
    if (items.length === 0) return null;
    return (
        <div className="block-faq">
            {items.map((item, i) => (
                <details key={i}>
                    <summary>{item.question}</summary>
                    <p>{item.answer}</p>
                </details>
            ))}
        </div>
    );
}
